import { render, staticRenderFns } from "./FooterItem01.vue?vue&type=template&id=e52e43ec&scoped=true&style=background-color%3A%23666"
import script from "./FooterItem01.vue?vue&type=script&lang=js"
export * from "./FooterItem01.vue?vue&type=script&lang=js"
import style0 from "./FooterItem01.vue?vue&type=style&index=0&id=e52e43ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52e43ec",
  null
  
)

export default component.exports